import React from 'react';
import { Stack, useTheme } from '@mui/material';
import { VTypography } from '@venti-components';
import Chip from '../../../../Venti-UI-Kit/Chip/Chip';

const PaymentMethodCard = ({ config, name }) => {
  const { paymentMethod } = config;
  const theme = useTheme();
  const textSecondary = theme.palette.text.secondary;
  return (
    <Stack
      sx={{ borderRadius: 2, width: 250, height: 100, p: 2 }}
      bgcolor={theme.palette.background.alternative}
    >
      <Stack gap={2} direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="column" justifyContent="space-between" alignItems="flex-start">
          <VTypography variant="body1" fontWeight={600}>
            {name}
          </VTypography>
          {paymentMethod && (
            <>
              <VTypography variant="body2" color={textSecondary}>
                Payment Method ID
              </VTypography>
              <VTypography variant="body2">{paymentMethod.id}</VTypography>
            </>
          )}
          {paymentMethod?.paymentAccountId && (
            <>
              <VTypography variant="body2" color={textSecondary}>
                Payment Account ID
              </VTypography>
              <VTypography variant="body2">{paymentMethod.paymentAccountId}</VTypography>
            </>
          )}
          {!paymentMethod && (
            <VTypography variant="body2" color={textSecondary}>
              Sin Payment Method
            </VTypography>
          )}
        </Stack>
        <Chip
          label={config.enabled ? 'Activo' : 'Inactivo'}
          bgcolor={config.enabled ? '#4caf50' : '#f44336'}
          labelColor="#fff"
          variant="filled"
        />
      </Stack>
    </Stack>
  );
};

export default PaymentMethodCard;
